import { Anchor, LockHollowSVG, PrintSVG } from "@newsela/angelou";
import PropTypes from "prop-types";

import { withTrackEvent } from "@newsela/snitch";

const propTypes = {
  __cssFor: PropTypes.object,
  children: PropTypes.node,
  flavor: PropTypes.string,
  isPrintDisabled: PropTypes.bool,
  printLink: PropTypes.string,
  streamProperties: PropTypes.object,
};

const AnchorWithTrackEvent = withTrackEvent(Anchor);

const PrintAssignment = ({
  __cssFor,
  children,
  flavor,
  isPrintDisabled,
  printLink,
  streamProperties,
}) => {
  const eventProperties = {
    objectType: "Assignment",
    actionPrefix: "Initiate",
    actionName: "Print",
    streamProperties: {
      ...streamProperties,
      description: "Print current assignment",
    },
  };

  return (
    <AnchorWithTrackEvent
      __cssFor={__cssFor}
      // see @link below for use of aria-disabled and role for disabled links
      ariaProps={
        isPrintDisabled ? { "aria-disabled": true, role: "link" } : undefined
      }
      dataProps={{ "data-qa-selector": "print-assignment-link" }}
      /**
       * To disable a link, remove its href attribute.
       * @link https://www.scottohara.me/blog/2021/05/28/disabled-links.html
       */
      href={!isPrintDisabled ? printLink : undefined}
      icon={{
        isIconBeforeText: true,
        ...(isPrintDisabled
          ? { SvgComponent: LockHollowSVG }
          : { __customOpenInNewTabIcon: PrintSVG }),
      }}
      openInNewTab={!isPrintDisabled}
      styleAnchorAsButton={{ flavor }}
      {...eventProperties}
    >
      {children}
    </AnchorWithTrackEvent>
  );
};

PrintAssignment.propTypes = propTypes;

export default PrintAssignment;
